import React, { memo, useState, useCallback } from "react";
import cx from "classnames";
import styles from "./Timeline.module.scss";
import _map from "lodash/map";
import _sortBy from "lodash/sortBy";
import text from "text";
import { SECTION_TYPE_VS_NAME } from "../../../../constants";
import Track from "./Track";
import TimelineCard from "./TimelineCard";

function Timeline({ className, sectionRef, sectionProps, sectionHeadingClassName }) {
  const timelineItems = _sortBy(text.timeline, [
    (item) => {
      const end = String(item.endDate || "").toLowerCase();
      return end === "present" || end === "now" ? 0 : 1;
    },
    (item) => -new Date(item.startDate).getTime(),
  ]);

  const [activeId, setActiveId] = useState(null);

  const handleHover = useCallback((id) => {
    setActiveId(id);
  }, []);

  return (
    <div className={cx(className, styles.sectionContainer)} ref={sectionRef} {...sectionProps}>
      <h2 className={sectionHeadingClassName}>
        {SECTION_TYPE_VS_NAME["TIMELINE"]}
      </h2>
      <div className={styles.timelineGrid}>
        <Track items={timelineItems} activeId={activeId} onHover={handleHover} />
        <div className={styles.cardColumn}>
          {_map(timelineItems, (item) => (
            <TimelineCard
              key={item.id}
              item={item}
              activeId={activeId}
              onHover={handleHover}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default memo(Timeline);
